import { getView } from '../../helpers/view';

const actions = {
  COLLAPSE_CHANGE: 'COLLAPSE_CHANGE',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  CLOSE_ALL: 'CLOSE_ALL',
  GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS: 'GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS',
  NOTIFICATION_MARK_AS_READ: 'NOTIFICATION_MARK_AS_READ',
  CHANGE_BREADCRUMB_STATE: 'CHANGE_BREADCRUMB_STATE',
  SET_INIT_BREADCRUMB_STATE: 'SET_INIT_BREADCRUMB_STATE',
  LOAD_THEME_REQUEST: 'LOAD_THEME_REQUEST',
  LOAD_THEME_SUCCESS: 'LOAD_THEME_SUCCESS',
  LOAD_THEME_ERROR: 'LOAD_THEME_ERROR',
  SET_SETTINGS_SIDEBAR_VISIBLE: 'SET_SETTINGS_SIDEBAR_VISIBLE',

  toggleCollapsed: payload => ({
    type: actions.COLLAPSE_CHANGE,
    payload,
  }),

  toggleAll: ({ width, height }) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';

    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height,
      width,
    };
  },

  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys,
  }),

  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current,
  }),

  closeAll: () => ({ type: actions.CLOSE_ALL }),

  getUnreadNotificationsCountSuccess: notificationsUnreadCount => ({
    type: actions.GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
    notificationsUnreadCount,
  }),

  notificationMarkAsRead: payload => ({
    type: actions.NOTIFICATION_MARK_AS_READ,
    payload,
  }),

  changeBreadcrumbState: data => ({
    type: actions.CHANGE_BREADCRUMB_STATE,
    data,
  }),

  setInitBreadcrumbState: data => ({
    type: actions.SET_INIT_BREADCRUMB_STATE,
    data,
  }),

  loadTheme: data => ({
    type: actions.LOAD_THEME_REQUEST,
    payload: data,
  }),

  loadThemeSuccess: data => ({
    type: actions.LOAD_THEME_SUCCESS,
    payload: data,
  }),

  loadThemeError: data => ({
    type: actions.LOAD_THEME_ERROR,
    payload: data,
  }),

  setSettingsSidebarVisible: visible => ({
    type: actions.SET_SETTINGS_SIDEBAR_VISIBLE,
    visible,
  }),
};

export default actions;
